import { useCalculatorConfig } from '../../../calculator-config/use-calculator-config';
import { useTranslation } from '../../../translations';
import { PanelHeader } from '../panel-header/panel-header';
import { Controls } from './controls/controls';

export const CalculatorControls = () => {
    const { yourSavings } = useTranslation();

    return (
        <section>
            <PanelHeader title={yourSavings} />
            <ConfiguredControls />
        </section>
    );
};

const ConfiguredControls = () => {
    const { type } = useCalculatorConfig();

    switch (type) {
        default:
            return <StandardControls />;
    }
};

const StandardControls = () => (
    <Controls>
        <Controls.InitialInvestment />
        <Controls.MonthlyContribution />
        <Controls.SavingPeriodYears />
    </Controls>
);
